var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "830.000000pt",
    height: "830.000000pt",
    viewBox: "0 0 830.000000 830.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#9AACCF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,830.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4790 7143 c-69 -35 -96 -153 -80 -358 5 -66 10 -127 10 -136 0 -9 22 -30 48 -47 l48 -31 825 -3 c927 -4 865 1 1034 -83 188 -92 334 -272 386 -473 18 -73 19 -128 19 -1815 0 -1941 5 -1795 -70 -1952 -91 -188 -263 -334 -470 -396 -75 -23 -78 -23 -911 -28 -819 -6 -837 -6 -859 -26 -52 -46 -72 -160 -61 -342 8 -135 17 -157 82 -201 l33 -23 856 4 c932 4 899 2 1085 63 382 127 717 459 844 840 70 208 66 83 66 2059 0 1667 -1 1786 -18 1875 -52 276 -176 504 -386 710 -191 186 -397 298 -661 357 -66 14 -178 17 -930 20 -803 3 -857 2 -890 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3137 6996 c-98 -36 -179 -129 -197 -225 -6 -33 -10 -312 -10 -722 l0 -669 -1077 -2 -1078 -3 -54 -30 c-31 -17 -71 -51 -93 -78 -72 -91 -69 -45 -66 -1093 3 -937 3 -939 24 -985 26 -57 88 -120 146 -151 l43 -23 1077 -3 1077 -2 3 -703 3 -702 22 -45 c29 -58 92 -123 146 -152 34 -18 58 -23 127 -23 75 0 91 3 136 28 37 21 404 382 1341 1320 1049 1050 1295 1301 1314 1342 16 35 23 68 23 115 2 137 103 25 -1332 1462 -950 951 -1309 1304 -1346 1324 -61 33 -169 43 -229 20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.53de10c8.svg";
export { ForwardRef as ReactComponent };